<div class="page-buttons" aria-label="Páginas">
  <ng-container *ngFor="let item of visiblePages">
    <span class="page-ellipsis" *ngIf="item === 'ellipsis'">...</span>
    <button
      *ngIf="item !== 'ellipsis'"
      class="page-button"
      type="button"
      [disabled]="disabled"
      [class.active]="page === item"
      [attr.aria-current]="page === item ? 'page' : null"
      (click)="pageChange.emit(item)">
      {{ item + 1 }}
    </button>
  </ng-container>
</div>
